// Color constants used across ManualSalary components
export const COLORS = {
  // Text colors
  TEXT_PRIMARY: "#1A2217",
  TEXT_SECONDARY: "#797D79",
  TEXT_MUTED: "#667085",
  TEXT_LIGHT: "#757575",
  TEXT_ICON: "#71777D",

  // Background colors
  BG_WHITE: "#ffffff",
  BG_LIGHT: "#f8f8f8",
  BG_LIGHTER: "#F8F8F8",

  // Border colors
  BORDER_LIGHT: "#d0d7e2",

  // Status colors
  STATUS_PENDING_BG: "#6720C00D",
  STATUS_PENDING_TEXT: "#4A32BD",
  STATUS_APPROVED_BG: "#ECFDF3",
  STATUS_APPROVED_TEXT: "#037847",
  STATUS_REJECTED_BG: "#CF0C0C1A",
  STATUS_REJECTED_TEXT: "#CF0C0C",
  STATUS_REWORKED_BG: "#FEB0121A",
  STATUS_REWORKED_TEXT: "#FEB012",
  // Default/unknown status (matches main listing btn-secondary)
  STATUS_DEFAULT_BG: "#6c757d",
  STATUS_DEFAULT_TEXT: "#ffffff",

  // Button colors
  BUTTON_PRIMARY: "#2726c9",
  BUTTON_DISABLED: "#9da3c1",

  ELECTRIC_NAVY: "#2825AD"
} as const;

// Field color configurations
export const FIELD_COLORS = {
  labelColor: COLORS.TEXT_SECONDARY,
  valueColor: COLORS.TEXT_PRIMARY,
  valueBgColor: COLORS.BG_WHITE,
  defaultLabelColor: undefined,
  defaultValueColor: COLORS.TEXT_LIGHT,
  defaultValueBgColor: COLORS.BG_LIGHT,
} as const;

// Common styles
export const COMMON_STYLES = {
  sectionTitle: {
    fontFamily: "Cairo",
    fontWeight: 500,
    fontSize: "22px",
    letterSpacing: "0",
  },
} as const;

export const RESIDENTIAL_TYPES = [
  {
    id: 1,
    name: "Rented",
    code: "R",
  },
  {
    id: 2,
    name: "Owned",
    code: "O",
  },
  {
    id: 3,
    name: "Company Provided",
    code: "CP",
  },
  {
    id: 4,
    name: "Living With parents",
    code: "LWP",
  },
];
